import { CaracteristicaCodigoEquipoModel } from '@/store/catalogos/caracteristicaCodigoEquipo';
import { CodigoEquipoModel } from '@/store/catalogos/codigoEquipo';
import { properties } from '@/utils/properties';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class CaracteristicaCodigoEquipoService {
  private readonly baseUrl = properties.URL_CATALOGOS + 'caracteristicaCodigoEquipos';

  constructor(private http: HttpClient) { }

  getAll(): Observable<CaracteristicaCodigoEquipoModel[]> {
    return this.http.get<CaracteristicaCodigoEquipoModel[]>(this.baseUrl, httpOptions);
  }

  create(codigoEquipo: CaracteristicaCodigoEquipoModel): Observable<CaracteristicaCodigoEquipoModel> {
    return this.http.post<CaracteristicaCodigoEquipoModel>(this.baseUrl, codigoEquipo, httpOptions);
  }

  update(codigoEquipo: CaracteristicaCodigoEquipoModel): Observable<CaracteristicaCodigoEquipoModel> {
    return this.http.put<CaracteristicaCodigoEquipoModel>(`${this.baseUrl}/${codigoEquipo.idCaracteristica}`, codigoEquipo, httpOptions);
  }
  getIdEquipo(codigoEquipo: number): Observable<CaracteristicaCodigoEquipoModel[]> {
    return this.http.get<CaracteristicaCodigoEquipoModel[]>(
      `${this.baseUrl}/equipo/${codigoEquipo}`, httpOptions);
  }
  


}
